const VectorData = [
  {
    id: 1,
    name: "Logo Designing",
    description: "Creating professional and creative logo designs that represent your brand identity in vector format.",
    "pname": "vector-img",
  },
  {
    id: 2,
    name: "Logo Vectorization",
    description: "Converting existing logo images into scalable vector formats (AI, SVG, EPS) for perfect printing and resizing.",
    "pname": "vector-img",
  },
  {
    id: 3,
    name: "Vector Color Separation",
    description: "Preparing vector artwork with precise color separations, ideal for screen printing and DTF processes.",
    "pname": "vector-img",
  },
  {
    id: 4,
    name: "Image Vectorization",
    description: "Transforming raster images (JPG, PNG) into clean, editable, and scalable vector graphics.",
    "pname": "vector-img",
  },
  {
    id: 5,
    name: "DTF Design",
    description: "Designing and preparing high-quality DTF-ready vector artwork optimized for print transfers.",
    "pname": "vector-img",
  },
  {
    id: 6,
    name: "Print Ready Files",
    description: "Delivering complete vector files ready for printing on any medium with perfect resolution and color setup.",
    "pname": "vector-img",
  },
  {
    id: 7,
    name: "JPG To Vector",
    description: "Converting JPG or other raster images into clean, scalable vector formats suitable for editing and printing.",
    "pname": "vector-img",
  }
];

export default VectorData;
